module.exports = __webpack_public_path__ + "img/Moderat_erhöhte_Aktivität.e5a4ef97.svg";